import { useEffect, useState } from "react";
import Navigation from "../components/Navigation";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import OptionalServices from "../components/OptionalServices";
import ProcessSection from "../components/ProcessSection";
import WhyChooseSection from "../components/WhyChooseSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="bg-white min-h-screen overflow-x-hidden">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <OptionalServices />
      <ProcessSection />
      <WhyChooseSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
